export class TaxInfoUpdateRequest {
  country: string;
  postalCode: string;
}
